export default "__VITE_ASSET__BeIuRMVC__"